import React from "react";
import { getViewportLayoutMm } from "../../engine/sheetLayoutUtils";
import {
  projectWorldToViewportMm,
  unprojectViewportMmToWorld,
  getSectionFrame2D,
} from "../../engine/viewProjection";



function getSvgElementFromEvent(e) {
  return e.currentTarget?.ownerSVGElement || e.currentTarget;
}

function getSvgPointMmFromClient(e, viewport, svg) {
  if (!svg || typeof svg.getBoundingClientRect !== "function") {
    return { x: 0, y: 0 };
  }

  const rect = svg.getBoundingClientRect();
  const layout = getViewportLayoutMm(viewport);

  return {
    x: ((e.clientX - rect.left) / rect.width) * layout.widthMm,
    y: ((e.clientY - rect.top) / rect.height) * layout.heightMm,
  };
}

function getSectionNormal2D(marker) {
  return getSectionFrame2D(marker).depth;
}

function getSectionMidPoint(marker, view) {
  const start = marker?.start || { x: -500, z: Number(marker?.value || 0) };
  const end = marker?.end || { x: 500, z: Number(marker?.value || 0) };

  return {
    x: (Number(start.x || 0) + Number(end.x || 0)) / 2,
    y: Number(view?.projection?.originWorld?.y || 0),
    z:
      marker?.value !== undefined
        ? Number(marker.value || 0)
        : (Number(start.z || 0) + Number(end.z || 0)) / 2,
  };
}

export default function SectionMarker({
  marker,
  viewport,
  view,
  onUpdateMarker,
  selected = false,
onSelect,
onUpdate,
screenPxPerMm = 3,
}) {
  const layout = getViewportLayoutMm(viewport);

  const widthMm = layout.widthMm;
  const heightMm = layout.heightMm;

  const sectionLetter = String(marker?.label || "A-A").split("-")[0] || "A";

const x1 = widthMm * 0.12;
const x2 = widthMm * 0.88;

const depth = Number(marker?.depth || 1000);

const basePoint2D = projectSectionPoint(marker, viewport, view, 0);
const depthPoint2D = projectSectionPoint(marker, viewport, view, depth);
const tickPoint2D = projectSectionPoint(marker, viewport, view, 160);
const arrowPoint2D = projectSectionPoint(marker, viewport, view, 260);

const y = basePoint2D.y;
const depthY = depthPoint2D.y;

const bandY = Math.min(y, depthY);
const bandH = Math.abs(depthY - y);

  function startMoveSection(e) {
  e.stopPropagation();
  e.preventDefault();

  const svg = getSvgElementFromEvent(e);

  const startPointMm = getSvgPointMmFromClient(e, viewport, svg);
  const startWorld = unprojectViewportMmToWorld(startPointMm, view, viewport);

  const originalValue = Number(marker.value || marker?.start?.z || 0);

  const originalStart = {
    ...(marker.start || {}),
    x: Number(marker?.start?.x ?? -500),
    z: Number(marker?.start?.z ?? originalValue),
  };

  const originalEnd = {
    ...(marker.end || {}),
    x: Number(marker?.end?.x ?? 500),
    z: Number(marker?.end?.z ?? originalValue),
  };

  function move(ev) {
    const currentPointMm = getSvgPointMmFromClient(ev, viewport, svg);
    const currentWorld = unprojectViewportMmToWorld(
      currentPointMm,
      view,
      viewport
    );

    const dz = currentWorld.z - startWorld.z;
    const nextValue = originalValue + dz;

    onUpdate?.({
      value: nextValue,
      start: {
        ...originalStart,
        z: originalStart.z + dz,
      },
      end: {
        ...originalEnd,
        z: originalEnd.z + dz,
      },
      camera: null,
    });
  }

  function up() {
    window.removeEventListener("mousemove", move);
    window.removeEventListener("mouseup", up);
  }

  window.addEventListener("mousemove", move);
  window.addEventListener("mouseup", up);
}

function startDepthDrag(e) {
  e.stopPropagation();
  e.preventDefault();

  const svg = getSvgElementFromEvent(e);
  const normal = getSectionNormal2D(marker);

  const startPointMm = getSvgPointMmFromClient(e, viewport, svg);
  const startWorld = unprojectViewportMmToWorld(startPointMm, view, viewport);

  const startDepth = Number(marker.depth || 1000);

  function move(ev) {
    const currentPointMm = getSvgPointMmFromClient(ev, viewport, svg);
    const currentWorld = unprojectViewportMmToWorld(
      currentPointMm,
      view,
      viewport
    );

    const dx = currentWorld.x - startWorld.x;
    const dz = currentWorld.z - startWorld.z;

    const deltaAlongDepth = dx * normal.x + dz * normal.z;

    onUpdate?.({
      depth: Math.max(10, startDepth + deltaAlongDepth),
      camera: null,
    });
  }

  function up() {
    window.removeEventListener("mousemove", move);
    window.removeEventListener("mouseup", up);
  }

  window.addEventListener("mousemove", move);
  window.addEventListener("mouseup", up);
}

  return (
    <svg
      className="absolute inset-0"
      width="100%"
      height="100%"
      viewBox={`0 0 ${widthMm} ${heightMm}`}
      style={{
        zIndex: 80,
        pointerEvents: "auto",
      }}
    >
      <rect
        x={x1}
        y={bandY}
        width={x2 - x1}
        height={bandH}
        fill="rgba(37,99,235,0.08)"
        stroke="rgba(37,99,235,0.25)"
        strokeWidth={0.3}
      />

      <line
        x1={x1}
        y1={y}
        x2={x2}
        y2={y}
        stroke={selected ? "#2563eb" : "#111827"}
  strokeWidth={selected ? 0.8 : 0.55}
  onMouseDown={(e) => {
  onSelect?.();
  startMoveSection(e);
}}
  style={{ cursor: "move" }}
      />

      <line
        x1={x1}
        y1={y}
        x2={x1}
        y2={tickPoint2D.y}
        stroke={selected ? "#2563eb" : "#111827"}
  strokeWidth={selected ? 0.8 : 0.55}
  onMouseDown={(e) => {
  onSelect?.();
  startMoveSection(e);
}}
  style={{ cursor: "move" }}
      />

      <line
        x1={x2}
        y1={y}
        x2={x2}
        y2={tickPoint2D.y}
        stroke={selected ? "#2563eb" : "#111827"}
  strokeWidth={selected ? 0.8 : 0.55}
  onMouseDown={(e) => {
  onSelect?.();
  startMoveSection(e);
}}
  style={{ cursor: "move" }}
      />

      <polygon
  points={`${widthMm / 2 - 3},${tickPoint2D.y} ${widthMm / 2 + 3},${tickPoint2D.y} ${widthMm / 2},${arrowPoint2D.y}`}
  fill="#111827"
/>

      <circle cx={x1} cy={y} r={3.2} fill="white" stroke="#111827" strokeWidth={0.5} />
      <circle cx={x2} cy={y} r={3.2} fill="white" stroke="#111827" strokeWidth={0.5} />

      <text
  x={x1}
  y={y + 1.1}
  fontSize={3}
  textAnchor="middle"
  fill="#111827"
  fontWeight="700"
>
  {sectionLetter}
</text>

      <text
  x={x2}
  y={y + 1.1}
  fontSize={3}
  textAnchor="middle"
  fill="#111827"
  fontWeight="700"
>
  {sectionLetter}
</text>

      <text
  x={widthMm / 2}
  y={arrowPoint2D.y + (arrowPoint2D.y >= y ? 5 : -5)}
  fontSize={3}
  textAnchor="middle"
  fill="#2563eb"
>
  Depth {Math.round(depth)} mm
</text>

      {selected ? (
  <circle
    cx={widthMm / 2}
    cy={depthY}
    r={3}
    fill="#2563eb"
    stroke="white"
    strokeWidth={0.8}
    onMouseDown={startDepthDrag}
    style={{ cursor: "ns-resize" }}
  />
) : null}
    </svg>
  );
}

function projectSectionPoint(marker, viewport, view, distanceWorld = 0) {
  const base = getSectionMidPoint(marker, view);
  const frame = getSectionFrame2D(marker);
  const depth = frame.depth;

  return projectWorldToViewportMm(
    {
      x: base.x + depth.x * distanceWorld,
      y: base.y,
      z: base.z + depth.z * distanceWorld,
    },
    view,
    viewport
  );
}